/**
 * Shared, conservative routing rules for returning from secure authentication.
 * Only same-site, application-relative paths are allowed to prevent open redirects.
 */
export function toSafeAppPath(value: string | null | undefined): string | undefined {
  if (!value) return undefined;

  const path = value.trim();
  if (!path.startsWith("/") || path.startsWith("//") || path.includes("\\") || path.includes("\u0000")) {
    return undefined;
  }

  return path;
}

/**
 * Administrators always enter the CRM after their server session confirms the role.
 * Members may return to the safe page that initiated secure sign-in, except admin routes.
 */
export function resolvePostLoginPath(
  role: string | null | undefined,
  requestedPath?: string | null,
): string {
  if (role === "admin") return "/admin";

  const safePath = toSafeAppPath(requestedPath);
  const isAdminPath = safePath === "/admin" || safePath?.startsWith("/admin?") || safePath?.startsWith("/admin/");

  return safePath && !isAdminPath ? safePath : "/my-events";
}
